import { Controller } from "@hotwired/stimulus"

// Przełącznik „Kod | Markdown” nad treścią markdown (partial components/tailwind/_markdown_code_view):
// pokazuje surowy tekst albo wyrenderowany podgląd. Wybór zapamiętuje w localStorage, a zdarzenie
// markdown-view:change na window przełącza od razu wszystkie bloki na stronie (np. strony szablonu).
export const MODES = ["code", "markdown"]
export const STORAGE_KEY = "markdown-view-mode"

// Nieznana albo pusta wartość (brak wpisu, stary format) - widok domyślny
export function normalizeMode(mode, fallback = "code") {
  return MODES.includes(mode) ? mode : fallback
}

export default class extends Controller {
  static targets = ["code", "rendered", "option"]
  static values = { mode: { type: String, default: "code" } }

  connect() {
    this.show(normalizeMode(readStoredMode(), this.modeValue))
  }

  // klik w przycisk przełącznika (data-markdown-view-mode-param)
  select(event) {
    const mode = normalizeMode(event.params.mode)
    storeMode(mode)
    this.dispatch("change", { target: window, detail: { mode } })
  }

  // zdarzenie z dowolnego bloku na stronie (także tego) - wszystkie pokazują ten sam widok
  sync(event) {
    this.show(normalizeMode(event.detail?.mode, this.modeValue))
  }

  show(mode) {
    this.codeTarget.hidden = mode !== "code"
    this.renderedTarget.hidden = mode !== "markdown"
    this.optionTargets.forEach((option) => {
      option.setAttribute("aria-pressed", option.dataset.markdownViewModeParam === mode ? "true" : "false")
    })
  }
}

// localStorage bywa niedostępny (tryb prywatny, zablokowane dane) - wtedy bez zapamiętywania
function readStoredMode() {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

function storeMode(mode) {
  try {
    localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    // brak zapisu nie blokuje przełączenia
  }
}
